import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Privacy Policy for Post Truck Chrome Extension</h1>
      <p>
        <em>Last Updated: 2024-09-03</em>
      </p>

      <p>
        Thank you for using the <strong>Post Truck Chrome Extension</strong>{' '}
        ("Extension"). Your privacy is important to us. This Privacy Policy
        explains how we collect, use, and protect any personal information we
        collect through the use of this Extension.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We aim to collect as little data as possible. However, we may collect
        the following types of information:
      </p>
      <ul>
        <li>
          <strong>Personal Data</strong>: We do not collect any personally
          identifiable information (such as name, email, or address) unless
          voluntarily provided by you.
        </li>
        <li>
          <strong>Non-Personal Data</strong>: We may collect certain
          non-personal information such as:
          <ul>
            <li>Browser type and version</li>
            <li>Operating system</li>
            <li>
              Usage data related to the Extension (e.g., interactions, features
              used)
            </li>
          </ul>
        </li>
        <li>
          <strong>Cookies</strong>: This Extension does not use cookies or other
          tracking technologies.
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>
        The information we collect is used solely for the following purposes:
      </p>
      <ul>
        <li>To provide and improve the features of the Extension.</li>
        <li>To ensure the Extension operates as intended.</li>
        <li>
          To monitor Extension usage for better performance and optimization.
        </li>
      </ul>

      <h2>3. Data Sharing and Disclosure</h2>
      <p>
        We do not sell, trade, or otherwise transfer any of your personal data
        to outside parties. However, we may share data under the following
        circumstances:
      </p>
      <ul>
        <li>
          <strong>Legal Requirements</strong>: If required by law or to respond
          to a legal request, we may disclose your information.
        </li>
        <li>
          <strong>Service Providers</strong>: We may share non-personal data
          with third-party service providers to assist with analytics, but only
          under strict confidentiality agreements.
        </li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We are committed to ensuring the security of your information. We use
        standard industry practices to protect your data. However, no method of
        data transmission over the internet or storage is 100% secure, and we
        cannot guarantee absolute security.
      </p>

      <h2>5. Data Retention</h2>
      <p>
        We only retain your information for as long as necessary to fulfill the
        purposes described in this Privacy Policy or as required by law.
      </p>

      <h2>6. Your Choices</h2>
      <p>Since we collect minimal data, you have the following options:</p>
      <ul>
        <li>
          <strong>Access</strong>: You can contact us to request a summary of
          the data we have collected about you (if any).
        </li>
        <li>
          <strong>Deletion</strong>: You can request that we delete any personal
          data we may have collected, though this is likely minimal or
          non-existent.
        </li>
      </ul>

      <h2>7. Changes to This Privacy Policy</h2>
      <p>
        We reserve the right to update this Privacy Policy at any time. Any
        changes will be posted to this page with the updated date. We encourage
        you to review this Privacy Policy periodically to stay informed.
      </p>

      <h2>8. Contact Us</h2>
      <p>
        If you have any questions or concerns regarding this Privacy Policy or
        your data, please contact us at:
      </p>
      <p>
        <strong>Email</strong>: khabibullosaydullaev@gmail.com
        <br />
        <strong>Address</strong>: Khabibullo Saydullaev, Tashkent, Uzbekistan
      </p>
    </div>
  );
};

export default PrivacyPolicy;
